<div class="row mb-5 doc-vente-facture-form" style="margin-top:2%">
    <div class="col-12">
        <div class="row mb-3 align-items-end">
            <div class="col-lg-4 col-md-6 mb-3 mb-md-0">
                <label class="d-block mb-1" for="labelFacture">Label</label>
                <input
                    id="labelFacture"
                    type="text"
                    class="form-control"
                    name="labelFacture"
                    [(ngModel)]="labelText"
                    [placeholder]="documentTypeLabel"
                />
            </div>
            <div class="col-lg-4 col-md-6">
                <label class="d-block mb-1" for="couleurFacture">Couleur du document</label>
                <div class="doc-vente-color-wrap">
                    <span class="doc-vente-color-value">{{ couleurText }}</span>
                    <input
                        id="couleurFacture"
                        type="color"
                        class="doc-vente-color-input"
                        name="couleurFacture"
                        [(ngModel)]="couleurText"
                        title="Choisir une couleur"
                    />
                </div>
            </div>
        </div>

        <div class="mb-4">
            <label class="form-label text-muted size15 mb-2 d-block">Date limite de paiement</label>
            <div class="doc-vente-facture-date-row">
                <div class="doc-vente-facture-radio-inline">
                    <div class="org-radio-wrapper doc-vente-facture-org-radio">
                        <input type="radio" name="dateLimiteFacture" id="facDlJours" class="org-radio-input" [value]="'jours'" [(ngModel)]="datePaiement">
                        <label class="org-radio-label" for="facDlJours"><span class="org-radio-dot"></span></label>
                    </div>
                    <label class="size15 doc-vente-facture-radio-caption mb-0" for="facDlJours">Jours</label>
                </div>
                <div class="doc-vente-facture-radio-inline">
                    <div class="org-radio-wrapper doc-vente-facture-org-radio">
                        <input type="radio" name="dateLimiteFacture" id="facDlMois" class="org-radio-input" [value]="'mois'" [(ngModel)]="datePaiement">
                        <label class="org-radio-label" for="facDlMois"><span class="org-radio-dot"></span></label>
                    </div>
                    <label class="size15 doc-vente-facture-radio-caption mb-0" for="facDlMois">Mois</label>
                </div>
                <div class="doc-vente-facture-radio-inline">
                    <div class="org-radio-wrapper doc-vente-facture-org-radio">
                        <input type="radio" name="dateLimiteFacture" id="facDlAnnee" class="org-radio-input" [value]="'annee'" [(ngModel)]="datePaiement">
                        <label class="org-radio-label" for="facDlAnnee"><span class="org-radio-dot"></span></label>
                    </div>
                    <label class="size15 doc-vente-facture-radio-caption mb-0" for="facDlAnnee">Année</label>
                </div>
                <div class="doc-vente-facture-stepper d-flex align-items-stretch flex-shrink-0">
                    <button type="button" class="minus-button-left"
                            (click)="decrement()"
                            [disabled]="disabledValueDecrement">-</button>
                    <input style="width: 90px; border-radius: 0"
                           type="number"
                           class="form-control text-center align-self-stretch"
                           name="minStock"
                           [(ngModel)]="numberValue"
                           (ngModelChange)="emitChange(numberValue)"/>
                    <button type="button" class="minus-button-right"
                            (click)="increment()"
                            [disabled]="disabledValueIncrement">+</button>
                </div>
            </div>
        </div>

        <div class="mb-2">
            <div class="custom-control custom-checkbox">
                <input class="custom-control-input" type="checkbox" id="facQr" name="facQr" [(ngModel)]="insrQrCd">
                <label class="custom-control-label" for="facQr">
                    Afficher le code QR
                </label>
            </div>
        </div>
        <div class="mb-2">
            <div class="custom-control custom-checkbox">
                <input class="custom-control-input" type="checkbox" id="facTotalCheckbox" name="facOrig" [(ngModel)]="insrOrigArtcl">
                <label class="custom-control-label" for="facTotalCheckbox">
                    Insérer l'origine des articles
                </label>
            </div>
        </div>

        <div class="mb-2">
            <div class="custom-control custom-checkbox">
                <input class="custom-control-input" type="checkbox" id="facContactCheckbox" name="facMt" [(ngModel)]="affMontantTotaux">
                <label class="custom-control-label" for="facContactCheckbox">
                    Afficher les montants totaux
                </label>
            </div>
        </div>

        <div class="mb-2">
            <div class="custom-control custom-checkbox">
                <input class="custom-control-input" type="checkbox" id="facContact" name="facContact" [(ngModel)]="affInfContact">
                <label class="custom-control-label" for="facContact">
                    Afficher les informations de contact
                </label>
            </div>
        </div>

        <div class="mb-2">
            <div class="custom-control custom-checkbox">
                <input class="custom-control-input" type="checkbox" id="facDesc" name="facDesc" [(ngModel)]="affCourteDesp">
                <label class="custom-control-label" for="facDesc">
                    Afficher une courte description
                </label>
            </div>
        </div>
        <div class="mb-2">
            <div class="custom-control custom-checkbox">
                <input class="custom-control-input" type="checkbox" id="facInfo" name="facInfo" [(ngModel)]="affInfos">
                <label class="custom-control-label" for="facInfo">
                    Afficher les informations
                </label>
            </div>
        </div>

        <div class="mb-1"><hr class="m-0 divis"></div>

        <div class="mb-2">
            <label class="form-check-label label-large d-block mb-2" for="noteFacture">
                Note
            </label>
            <textarea id="noteFacture" class="form-control note" name="noteFacture" [(ngModel)]="noteText" placeholder="Saisissez une note" rows="4"></textarea>
        </div>
    </div>
</div>

<div class="d-flex justify-content-end align-items-center flex-wrap w-100 position-fixed-bottom mt-2 mb-2">
    <a class="btn btn-grey waves-effect m-1" routerLink="/main/parametre/document">Annuler</a>
    <button type="button" class="btn btn-green waves-effect m-1" (click)="appercue()">Aperçu de la configuration</button>
    <button type="button" class="btn btn-primary waves-effect m-1" (click)="saveParametreDocument()" [disabled]="saving">{{ saving ? 'Enregistrement…' : 'Enregistrer' }}</button>
</div>
